/**
 * Platform-agnostic key-value storage interface.
 *
 * Implement this interface once per platform and inject it into createApiClient():
 *   - Web:     localStorage (synchronous)
 *   - React Native: AsyncStorage (async — wrap in a promise-compatible adapter)
 *   - Tauri:   @tauri-apps/plugin-store or localStorage (in webview)
 *
 * All methods may return a Promise or a plain value to accommodate both
 * synchronous (localStorage) and asynchronous (AsyncStorage) implementations.
 */
export interface StorageAdapter {
  getItem(key: string): string | null | Promise<string | null>;
  setItem(key: string, value: string): void | Promise<void>;
  removeItem(key: string): void | Promise<void>;
}

/**
 * A ready-to-use synchronous adapter backed by the browser's localStorage.
 * Import this in packages/web — do NOT import it in packages/mobile or packages/desktop.
 */
export const localStorageAdapter: StorageAdapter = {
  getItem: (key) => localStorage.getItem(key),
  setItem: (key, value) => localStorage.setItem(key, value),
  removeItem: (key) => localStorage.removeItem(key),
};
